import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Provider } from 'react-redux';
import store from './store'; // Import your store
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { refreshOrganizationId } from "./utils/organizationRefresh";
import AppConfirmProvider from "./components/AppConfirmProvider";
import {
  installBrowserPopupOverrides,
  TOAST_POSITION,
} from "./utils/appNotify";
import { installFormSubmitGuard } from "./utils/formSubmitGuard";

// Replace browser alert/confirm with top-right toast / side confirm UI
installBrowserPopupOverrides();
// Disable form submit buttons while submitting (blocks double-submit)
installFormSubmitGuard();

// Check and refresh organizationId IMMEDIATELY on page load, before React renders
// This ensures organizationId is set before any API calls are made
(function checkOrganizationIdOnLoad() {
  console.log("[index.js] ========================================");
  console.log("[index.js] Checking organizationId on page load...");
  const storedUser = localStorage.getItem("user");
  if (storedUser) {
    try {
      const parsedUser = JSON.parse(storedUser);
      console.log("[index.js] User found:", { id: parsedUser?.id, role: parsedUser?.roleName, orgId: parsedUser?.organizationId });
      console.log("[index.js] Full user object:", parsedUser);
      
      // Check if user is a base user (organizationId is explicitly null, not just missing)
      // Base users should not have organizationId refreshed
      const isBaseUser = parsedUser?.organizationId === null || 
                        (parsedUser?.organizationId === undefined && !parsedUser?.hasOwnProperty('organizationId'));
      
      if (isBaseUser) {
        console.log("[index.js] ℹ️ Base user detected - skipping organizationId refresh");
        console.log("[index.js] Base user will use base tables instead of organization-specific tables.");
      } else if (!parsedUser?.organizationId || parsedUser.organizationId === "" || Number(parsedUser.organizationId) <= 0) {
        console.log("[index.js] ⚠️⚠️⚠️ organizationId MISSING - attempting refresh BEFORE React renders...");
        console.log("[index.js] This will call getStaffByUserId which should find user in organization 4");
        
        // Run refresh but don't block rendering
        refreshOrganizationId().then((orgId) => {
          if (orgId) {
            console.log(`[index.js] ✅✅✅ SUCCESS! Refreshed organizationId: ${orgId}`);
            console.log(`[index.js] Reloading page to apply organizationId to all requests...`);
            // Small delay to ensure localStorage is written
            setTimeout(() => {
              window.location.reload();
            }, 500);
          } else {
            console.warn("[index.js] ⚠️ Could not refresh organizationId");
            console.warn("[index.js] User might not be in any staff table, or workaround failed");
          }
        }).catch((error) => {
          console.error("[index.js] ❌ Error refreshing organizationId:", error);
        });
      } else {
        console.log(`[index.js] ✅ organizationId already set: ${parsedUser.organizationId}`);
      }
    } catch (e) {
      console.error("[index.js] Error checking organizationId:", e);
    }
  } else {
    console.log("[index.js] No user found in localStorage");
  }
  console.log("[index.js] ========================================");
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}> {/* Wrap with Provider */}
  <AuthProvider>
    <AppConfirmProvider>
      <ToastContainer
        position={TOAST_POSITION}
        autoClose={3000}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable={false}
        hideProgressBar
        limit={3}
        style={{ zIndex: 14000 }}
        toastClassName="app-toast-compact"
      />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AppConfirmProvider>
  </AuthProvider>
  </Provider>
  // </React.StrictMode>
);
